module.exports = __webpack_public_path__ + "img/logo.9231a3b4.png";